import React from "react";
import { Box, Text } from "@mantine/core";
import { IconTag } from "@tabler/icons-react";
import styles from "./appointmentTags.module.css";

export interface AppointmentTagChipProps {
  name: string;
  /** The tag's emoji; null/empty renders the default tag icon. */
  emoji?: string | null;
}

/**
 * Read-only tag chip: an emoji (or the default tag icon) prefix + the name,
 * as a soft teal pill. Mirrors the design prototype's drawer tag chip.
 */
export default function AppointmentTagChip({
  name,
  emoji,
}: AppointmentTagChipProps) {
  return (
    <Box component="span" className={styles.chip}>
      {emoji ? (
        <Text component="span" className={styles.chipEmoji} aria-hidden>
          {emoji}
        </Text>
      ) : (
        <IconTag
          size={12}
          stroke={2.2}
          aria-hidden
          data-testid="tag-chip-default-icon"
        />
      )}
      <Text component="span" className={styles.chipName}>
        {name}
      </Text>
    </Box>
  );
}
